var exports = {
  "GE": "AvatarStack__smDpdt",
  "az": "Box__ezCsxQ",
  "re": "GitHubAvatar__LHhMmN",
  "mz": "TextCell__GIHFE9",
  "iB": "TextCell_1__KVYw6H",
};

module.exports = exports;
